import { useState } from "react";
import { Repeat, Pause, Play, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const RecurringList = ({ 
  subscriptions, 
  showSection, 
  onToggleSection,
  onToggleRecurring, 
  onDeleteRecurring 
}) => {
  return (
    <Card>
      <CardHeader 
        className="cursor-pointer hover:bg-slate-50"
        onClick={onToggleSection}
      >
        <div className="flex items-center justify-between">
          <CardTitle className="flex items-center gap-2">
            <Repeat className="w-5 h-5 text-purple-500" />
            Abonnements Récurrents
            <Badge className="bg-purple-100 text-purple-700">{subscriptions.length}</Badge>
          </CardTitle>
          <span className="text-slate-400">{showSection ? "▼" : "▶"}</span>
        </div>
      </CardHeader>
      {showSection && (
        <CardContent>
          {subscriptions.length === 0 ? (
            <p className="text-slate-500 text-center py-4">Aucun récurrent programmé</p>
          ) : (
            <div className="space-y-3">
              {subscriptions.map((sub) => (
                <div 
                  key={sub.id}
                  className={`flex items-center justify-between p-3 rounded-lg border ${sub.is_active ? "bg-white" : "bg-gray-50 opacity-70"}`}
                >
                  <div className="flex items-center gap-3">
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center ${sub.is_active ? "bg-pink-100" : "bg-gray-200"}`}>
                      <Repeat className={`w-5 h-5 ${sub.is_active ? "text-pink-600" : "text-gray-400"}`} />
                    </div>
                    <div>
                      <p className="font-medium">
                        {sub.first_name} {sub.last_name}
                        {!sub.is_active && <Badge className="ml-2 bg-gray-200 text-gray-600">Pause</Badge>}
                        {sub.frequency === "biweekly" && <Badge className="ml-2 bg-purple-100 text-purple-700">1 sem./2</Badge>}
                      </p>
                      <p className="text-sm text-slate-500">
                        {sub.frequency === "biweekly" ? "Un " : "Tous les "}<strong>{sub.day_name}{sub.frequency === "biweekly" ? " sur deux" : "s"}</strong> • {sub.zone_id === "lyon" ? "Lyon" : "Saint-Rambert"}
                      </p>
                      <p className="text-xs text-slate-400">{sub.customer_email}</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => onToggleRecurring(sub.id)}
                      title={sub.is_active ? "Mettre en pause" : "Réactiver"}
                    >
                      {sub.is_active ? <Pause className="w-4 h-4" /> : <Play className="w-4 h-4" />}
                    </Button>
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => onDeleteRecurring(sub.id)}
                      className="text-red-500 hover:bg-red-50"
                      title="Supprimer"
                    >
                      <Trash2 className="w-4 h-4" />
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      )}
    </Card>
  );
};

export default RecurringList;
